import { Fragment } from "react";
import { Button, message } from "antd";
import { useHistory } from "react-router-dom";
import { deleteOne } from "../../../api/user";

/**
 * DeleteUser
 * @param {Object} user
 * @param {Function} closeModal
 */
function DeleteUser({ user, closeModal }) {
  const history = useHistory();

  // ------ Elimina usuario ------
  const handleDelete = async (userId) => {
    try {
      const response = await deleteOne(userId);
      message.success(response.message);
      closeModal();
      history.replace("/app/usuarios");
      window.location.reload();
    } catch (err) {
      message.error(err.message);
    }
  };

  // ----- render -----
  return (
    <Fragment>
      <p className="my-5">
        ¿Estás seguro de eliminar al usuario
        <span className="text-red-500 my-5">{" " + user.firstName + " " + user.lastName}</span>?
      </p>
      <Button type="danger" block htmlType="submit" onClick={() => handleDelete(user._id)}>
        Eliminar
      </Button>
    </Fragment>
  );
}
export default DeleteUser;
